import { useEffect, useState } from 'react';
import { windowIsDefined } from '@klv/shared/utils/functions';

export const useWindowDimensions = () => {
  const getWindowDimensions = () => {
    const dimensions = {
      width: 1366,
      height: 768,
    };

    if (windowIsDefined()) {
      dimensions.width = window.innerWidth;
      dimensions.height = window.innerHeight;
    }

    return dimensions;
  };

  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    // Get real dimensions on mount
    setWindowDimensions(getWindowDimensions());

    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};
